export const serverTabs = [
  { id: 'overview', label: '概要' },
  { id: 'console', label: 'コンソール' },
  { id: 'players', label: 'プレイヤー' },
  { id: 'files', label: 'ファイル' },
  { id: 'extensions', label: '拡張' },
  { id: 'backups', label: 'バックアップ' },
  { id: 'settings', label: '設定' },
] as const;
export type ServerTab = (typeof serverTabs)[number]['id'];
export const serverSections = {
  extensions: [
    { id: 'mods', label: 'Mod・プラグイン' },
    { id: 'bedrock', label: '統合版' },
    { id: 'ports', label: 'ポート' },
    { id: 'launcher', label: 'ランチャー' },
  ],
  settings: [
    { id: 'game-settings', label: 'ゲーム設定' },
    { id: 'software', label: 'ソフトとバージョン' },
    { id: 'resources', label: 'リソース' },
    { id: 'schedule', label: 'スケジュール' },
    { id: 'danger', label: '危険な操作' },
  ],
};
export function resolveServerLocation(params: URLSearchParams): { tab: ServerTab; section: string } {
  const oldTab = params.get('tab') ?? 'overview';
  const legacySection = params.get('section') ?? oldTab;
  if (['world-generation', 'regenerate-world'].includes(legacySection)) return { tab: 'settings', section: 'danger' };
  const section = oldTab === 'launch' ? 'resources' : oldTab;
  for (const tab of ['extensions', 'settings'] as const) {
    const sections = serverSections[tab];
    if (sections.some((item) => item.id === section)) return { tab, section };
    if (oldTab === tab) {
      const requested = params.get('section') === 'launch' ? 'resources' : params.get('section');
      return { tab, section: sections.find((item) => item.id === requested)?.id ?? sections[0]!.id };
    }
  }
  if (oldTab === 'snapshots') return { tab: 'backups', section: '' };
  return { tab: serverTabs.find((item) => item.id === oldTab)?.id ?? 'overview', section: '' };
}
